import Vue from 'vue'
import currencyFormatFilter from '../../filters/currency-format-filter'
import capitalizeFilter from '../../filters/capitalize-filter'
import dateFormatFilter from '../../filters/date-format-filter'
import cardNoFilter from '../../filters/card-no-filter'
import corpRegNoFilter from '../../filters/corp-reg-no-filter'
import fileSizeFormatFilter from '../../filters/file-size-format-filter'
import maskingFilter from '../../filters/masking-filter'
import jsonFormatFilter from '../../filters/json-format-filter'

export const registerFilters = () => {
  Vue.filter('currencyFormat', currencyFormatFilter)
  Vue.filter('capitalize', capitalizeFilter)
  Vue.filter('dateFormat', dateFormatFilter)
  Vue.filter('cardNo', cardNoFilter)
  Vue.filter('corpRegNo', corpRegNoFilter)
  Vue.filter('fileSizeFormat', fileSizeFormatFilter)
  Vue.filter('masking', maskingFilter)
  Vue.filter('jsonFormat', jsonFormatFilter)
}
